import React, { useState, useEffect, useRef } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link, useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import TableauDynamique from "../../composant_reutilisable/tableau";
import { BsPeople } from "react-icons/bs";
import { Modal, Button } from "react-bootstrap"; // Ajout du modal Bootstrap
import ModalComponent from "../../composant_reutilisable/composant_modal";
import { FaCogs, FaEye, FaPlus, FaQuestionCircle, FaTrash, FaExclamationTriangle, FaSortAmountDown, FaSortAmountUp, FaEllipsisV, FaEdit, FaShareAlt, FaBan, FaUndo, FaCheck, FaBell } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Footer from "../../composant_reutilisable/footer";

const ListeEvenementSignales = () => {
    // useAuth();
    const navigate = useNavigate();

    // const utilisateur_id = localStorage.getItem("utilisateur_id");
    const [isLoading, setIsLoading] = useState(false);
    const [menu, setMenu] = useState(null);
    const menuRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const user_id = localStorage.getItem('userId');
    const [selectedEvenement, setSelectedEvenement] = useState(null);
    const [selectedTraitement, setSelectedTraitement] = useState(null);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const [sortConfig, setSortConfig] = useState({ key: "date_evenement", direction: "descending" });
    const [filtreStatut, setFiltreStatut] = useState("tous");
    const [traitements, setTraitements] = useState([]);
    const [evenements, setEvenements] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [evenementSelectionne, setGroupeSelectionne] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentTab, setCurrentTab] = useState("non_traites");
    const [sortConfigTraitements, setSortConfigTraitements] = useState({ key: "date_traitement", direction: "descending" });
    const [showSuspendModal, setShowSuspendModal] = useState(false);
    const [showRetirerModal, setShowRetirerModal] = useState(false);
    const [evenementAModifier, setEvenementAModifier] = useState(null);
    // const location = useLocation();
    // const searchParams = new URLSearchParams(location.search);
    // const initialTab = searchParams.get('tab') === 'traites' ? 'tab-2' : 'tab-1';


    useEffect(() => {
        if (user_id) {
            document.title = "Showtime | Liste évènements signalés";
        }
    }, [user_id]);

    // États pour gérer le modal
    const [showModal, setShowModal] = useState(false);


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        setTimeout(() => {
            setAlertModal({ message: '', type: '' });
        }, 5000);
    };

    // Récupération des evenements
    const fetchEvenements = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-evenement-signales/");
            if (response.ok) {
                const data = await response.json();
                setEvenements(data);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération des évenements signalés:", error);
        }
    };

    useEffect(() => {
        fetchEvenements();
    }, []);

    // Récupération des traitements
    const fetchTraitements = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_HOTE + "/historique-traitement/");
            if (response.ok) {
                const data = await response.json();
                console.log("Traitements récupérés:", data);
                setTraitements(data);
            } else {
                console.error("Erreur lors de la récupération des traitements:", response.status);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération des traitements:", error);
        }
    };
    useEffect(() => {
        fetchTraitements();
    }, []);


    // Filtrage
    const evenementsFiltres = evenements.filter(evenement =>
        evenement?.nom?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.lieu?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.date_evenement?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.est_transferable?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.statut?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.Utilisateur?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.nombre_signalement?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const filteredEvenements = evenements.filter(evenement => {
        const matchesSearch =
            evenement?.nom?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            evenement?.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            evenement?.lieu?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            evenement?.date_evenement?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            evenement?.est_transferable?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            evenement?.statut?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            evenement?.Utilisateur?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            evenement?.nombre_signalement?.toLowerCase().includes(searchTerm.toLowerCase())

        const matchesStatus = filtreStatut === "tous" || evenement.statut === filtreStatut;

        return matchesSearch && matchesStatus;
    });

    const sortedEvenements = [...filteredEvenements].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    const sortedTraitements = [...traitements].sort((a, b) => {
        if (a[sortConfigTraitements.key] < b[sortConfigTraitements.key]) {
            return sortConfigTraitements.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfigTraitements.key] > b[sortConfigTraitements.key]) {
            return sortConfigTraitements.direction === "ascending" ? 1 : -1;
        }
        return 0;
    });

    const handleSortTraitements = (key) => {
        setSortConfigTraitements({
            key,
            direction: sortConfigTraitements.key === key && sortConfigTraitements.direction === "ascending" ? "descending" : "ascending"
        });
    };

    // Pagination
    const totalItems = evenementsFiltres.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfLastEvenement = currentPage * itemsPerPage;
    const indexOfFirstEvenement = indexOfLastEvenement - itemsPerPage;
    const indexOfLastTraitement = currentPage * itemsPerPage;
    const indexOfFirstTraitement = indexOfLastTraitement - itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentEvenements = sortedEvenements.slice(indexOfFirstEvenement, indexOfLastEvenement);
    const currentTraitements = sortedTraitements.slice(indexOfFirstTraitement, indexOfLastTraitement);
    const evenementsAffiches = evenementsFiltres.slice(indexOfFirstItem, indexOfLastItem);


    // Gestion du modal
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    // Gestion du formulaire d'ajout
    const handleClick = (event, evenement) => {
        event.stopPropagation();

        // Fermer le menu si c'est le même événement
        if (menu?.evenement?.evenement_id === evenement.evenement_id) {
            setMenu(null);
            return;
        }

        const buttonRect = event.currentTarget.getBoundingClientRect();

        setMenu({
            evenement,
            x: buttonRect.left,
            y: buttonRect.bottom
        });
    };

    const closeMenu = () => setMenu(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isActionButton = event.target.closest(".action-button");
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !isActionButton
            ) {
                closeMenu();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [menu]);





    const handleSort = (key) => {
        setSortConfig({
            key,
            direction: sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending"
        });
    };

    const nombreNonTraites = evenements.filter(evenement => evenement.statut === "2").length;
    const nombreDejaTraites = traitements.length;

    console.log("Événements traités:", evenements.filter(evenement =>
        evenement.statut === "1" || evenement.statut === "3"
    ));

    const handleShowDeleteModal = (evenementSelectionne) => {
        setGroupeSelectionne(evenementSelectionne);
        if (!evenementSelectionne) return;
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const colonnesdropdown = [
        {
            label: "Retirer",
            icon: <FaCogs color="blue" />,
            actionKey: "retirer",
        },
        {
            label: "Suspendre",
            icon: <FaTrash color="red" />,
            actionKey: "suspendre",
        },
    ];



    const menuStyle = {
        position: "absolute",
        backgroundColor: "white",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        borderRadius: "4px",
        zIndex: 1000,
        minWidth: "150px",
        border: "1px solid #ddd",
        padding: "5px 0",
        right: "auto", // S'assure qu'il n'y a pas de position right
        left: 0, // Positionné à gauche
    };

    const menuItemStyle = {
        padding: "8px 16px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        ":hover": {
            backgroundColor: "#f5f5f5",
        },
    };




    const MenuItem = ({ icon, color, label, onClick }) => (
        <li className="context-menu-item" onClick={onClick}>
            <span className="context-menu-icon" style={{ color }}>
                {icon}
            </span>
            <span>{label}</span>
        </li>
    );


    const notifierHoster = async (evenement_id) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/notifier-hoster/${evenement_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ evenement_id }),
            });

            if (!response.ok) {
                throw new Error('Erreur lors de la notification');
            }

            return await response.json();
        } catch (error) {
            console.error("Erreur:", error);
            throw error;
        }
    };

    const handleSuspendEvent = async (evenement) => {
    if (!evenement?.evenement_id) {
        console.error("Aucun événement sélectionné");
        return;
    }

    try {
        console.log("Tentative de suspension de l'événement:", evenement.evenement_id);
        const response = await fetch(`${process.env.REACT_APP_HOTE}/suspendre-evenement/${evenement.evenement_id}/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 
                evenement_id: evenement.evenement_id,
                user_id: user_id // Ajoutez l'ID de l'utilisateur qui effectue l'action
            }),
        });

        console.log("Réponse API suspension:", response);

        if (response.ok) {
            const data = await response.json();
            console.log("Succès suspension:", data);
            showAlert("Événement suspendu avec succès", "success");
            fetchEvenements();
            fetchTraitements();
        } else {
            const errorData = await response.json();
            console.error("Erreur API suspension:", errorData);
            throw new Error(errorData.message || 'Erreur lors de la suspension');
        }
    } catch (error) {
        console.error("Erreur suspension:", error);
        showAlert(error.message || "Erreur lors de la suspension de l'événement", "danger");
    }
};

const handleRestoreEvent = async (evenement) => {
    if (!evenement?.evenement_id) {
        console.error("Aucun événement sélectionné");
        return;
    }

    try {
        console.log("Tentative de restauration de l'événement:", evenement.evenement_id);
        const response = await fetch(`${process.env.REACT_APP_HOTE}/restaurer-evenement/${evenement.evenement_id}/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 
                evenement_id: evenement.evenement_id,
                user_id: user_id // Ajoutez l'ID de l'utilisateur qui effectue l'action
            }),
        });

        console.log("Réponse API restauration:", response);

        if (response.ok) {
            const data = await response.json();
            console.log("Succès restauration:", data);
            showAlert("Événement restauré avec succès", "success");
            fetchEvenements();
            fetchTraitements();
        } else {
            const errorData = await response.json();
            console.error("Erreur API restauration:", errorData);
            throw new Error(errorData.message || 'Erreur lors de la restauration');
        }
    } catch (error) {
        console.error("Erreur restauration:", error);
        showAlert(error.message || "Erreur lors de la restauration de l'événement", "danger");
    }
};

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaExclamationTriangle size={25} className='mr-2' />Gestion des évènements signalés
                                </div>

                                {/* Bouton d'aide complètement à droite */}

                            </h2>
                            {/* <small>Administration des évènements signalés.</small> */}

                            <small id='hbreadcrumb' className='d-flex justify-content-between align-items-center'>
                                <span>Gestion des évènements signalés</span>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Evènements signalés
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des évènements signalés</h5>

                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="tabs-container mb-4">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li>
                                            <a className="nav-link active" data-toggle="tab" href="#tab-1">
                                                Non traité ({nombreNonTraites})
                                            </a>
                                        </li>
                                        <li>
                                            <a className="nav-link" data-toggle="tab" href="#tab-2">
                                                Déjà traité ({nombreDejaTraites})
                                            </a>
                                        </li>
                                    </ul>

                                    <div className="tab-content">
                                        <div role="tabpanel" id="tab-1" className="tab-pane active">
                                            <div className="panel-body">

                                                <div className="ibox">

                                                    <div
                                                        className="d-flex justify-content-between align-items-center mb-3"
                                                        style={{ gap: "10px" }}
                                                    >
                                                        <div
                                                            className="d-flex align-items-center"
                                                            style={{ gap: "10px" }}
                                                        >
                                                            <select
                                                                id="itemsPerPage"
                                                                value={itemsPerPage}
                                                                onChange={(e) => {
                                                                    setItemsPerPage(Number(e.target.value));
                                                                    setCurrentPage(1);
                                                                }}
                                                                className="form-select bg-default p-1"
                                                                style={{
                                                                    width: "auto",
                                                                    border: "1px black solid",
                                                                    borderRadius: "5px",
                                                                }}
                                                            >
                                                                <option value={10}>10</option>
                                                                <option value={20}>20</option>
                                                                <option value={50}>50</option>
                                                            </select>
                                                            {/* <select
                                                                value={filtreStatut}
                                                                onChange={(e) =>
                                                                    setFiltreStatut(e.target.value)
                                                                }
                                                                className="form-select bg-default p-1"
                                                                style={{
                                                                    width: "auto",
                                                                    border: "1px black solid",
                                                                    borderRadius: "5px",
                                                                }}
                                                            >
                                                                <option value="tous">Tous</option>
                                                                <option value="Signalé">Signalés</option>
                                                                <option value="Suspendu">Suspendu</option>
                                                                <option value="Retiré">Retiré</option>
                                                            </select> */}
                                                        </div>

                                                        <input
                                                            type="text"
                                                            placeholder="Rechercher..."
                                                            className="form-control"
                                                            style={{ maxWidth: "250px", width: "100%" }}
                                                            value={searchTerm}
                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="table-responsive">
                                                        <table
                                                            className="footable table table-stripped footable-loaded tablet breakpoint"
                                                            data-page-size="8"
                                                            data-filter="#filter"
                                                            style={{ fontSize: "12px" }}
                                                        >
                                                            <thead>

                                                                <tr>
                                                                    <th
                                                                        className="text-secondary text-wrap  d-none d-md-table-cell"
                                                                        onClick={() => handleSort("nom")}
                                                                        style={{ width: "9%", minWidth: "100px" }}
                                                                    >
                                                                        Nom
                                                                        {sortConfig.key === "nom"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>
                                                                    {/* <th
                                                                        className="text-secondary text-wrap  d-none d-md-table-cell"
                                                                        onClick={() => handleSort("description")}
                                                                        style={{ width: "13%", minWidth: "100px" }}
                                                                    >
                                                                        Description
                                                                        {sortConfig.key === "description"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th> */}
                                                                    <th
                                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell  align-middle"
                                                                        onClick={() => handleSort("lieu")}
                                                                        style={{ width: "5%", minWidth: "100px" }}
                                                                    >
                                                                        Lieu
                                                                        {sortConfig.key === "lieu"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>
                                                                    <th
                                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell  align-middle"
                                                                        onClick={() => handleSort("date_evenement")}
                                                                        style={{ width: "10%", minWidth: "100px" }}
                                                                    >
                                                                        Date évènement
                                                                        {sortConfig.key === "date_evenement"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                                        onClick={() => handleSort("statut")}
                                                                        style={{ width: "7%", minWidth: "80px" }}
                                                                    >
                                                                        Statut
                                                                        {sortConfig.key === "statut"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>
                                                                    <th
                                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell"
                                                                        onClick={() => handleSort("nombre_signalement")}
                                                                        style={{ width: "9%", minWidth: "100px" }}
                                                                    >
                                                                        Signalements
                                                                        {sortConfig.key === "nombre_signalement"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>
                                                                    <th
                                                                        className="text-secondary text-wrap  d-none d-md-table-cell"
                                                                        onClick={() => handleSort("hoster")}
                                                                        style={{ width: "9%", minWidth: "100px" }}
                                                                    >
                                                                        Hoster
                                                                        {sortConfig.key === "hoster"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>

                                                                    <th
                                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell"
                                                                        style={{ width: "1%", minWidth: "60px" }}
                                                                    >
                                                                        Actions
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentEvenements && currentEvenements.length > 0 ? (
                                                                    currentEvenements.map((evenement) => (
                                                                        <tr
                                                                            key={evenement.evenement_id}
                                                                            // onClick={() => {
                                                                            //     // Si la ligne est déjà sélectionnée, on la désélectionne
                                                                            //     if (selectedEvenement?.evenement_id === evenement.evenement_id) {
                                                                            //         setSelectedEvenement(null);
                                                                            //     } else {
                                                                            //         setSelectedEvenement(evenement);
                                                                            //     }
                                                                            // }}
                                                                            style={{ cursor: "pointer" }}
                                                                            className={`bg-white ${selectedEvenement?.evenement_id === evenement.evenement_id ? "bg-success text-white" : ""}`}
                                                                        >

                                                                            <td
                                                                                className="d-none d-md-table-cell  align-middle"
                                                                                style={{ padding: "0.5rem" }}
                                                                            >
                                                                                <span>{evenement.nom}</span>
                                                                            </td>
                                                                            {/* <td
                                                                                className="d-none d-md-table-cell  align-middle"
                                                                                style={{ padding: "0.5rem" }}
                                                                            >
                                                                                <span className="fw-semibold">{evenement.description}</span>
                                                                            </td> */}
                                                                            <td
                                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                                style={{ padding: "0.5rem" }}
                                                                            >
                                                                                <span className="fw-semibold">{evenement.lieu}</span>
                                                                            </td>
                                                                            <td
                                                                                className="-none d-md-table-cell text-center align-middle"
                                                                                style={{ padding: "0.5rem" }}
                                                                            >
                                                                                <span className="fw-semibold">{evenement.date}</span>
                                                                            </td>
                                                                            <td
                                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                                style={{ padding: "0.5rem" }}
                                                                            >
                                                                                <div className={`badge fw-semibold ${evenement.statut === "2" || evenement.statut === "Signalé"
                                                                                    ? "bg-danger text-white"
                                                                                    : evenement.statut === "3" || evenement.statut === "Suspendu"
                                                                                        ? "bg-warning text-dark"
                                                                                        : evenement.statut === "1" || evenement.statut === "Disponible"
                                                                                            ? "bg-secondary text-white"
                                                                                            : ""
                                                                                    }`}>

                                                                                    {evenement.statut === "2" ? "Signalé" :
                                                                                        evenement.statut === "3" ? "Suspendu" :
                                                                                            evenement.statut === "1" ? "Disponible" : evenement.statut}

                                                                                </div>
                                                                            </td>
                                                                            <td
                                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                                style={{ padding: "0.5rem" }}>
                                                                                <div className="fw-semibold">{evenement.nombre_signalement}</div>
                                                                            </td>
                                                                            <td
                                                                                className="d-none d-md-table-cell  align-middle"
                                                                                style={{ padding: "0.5rem" }}>
                                                                                <div className="fw-semibold">{evenement.hoster}</div>
                                                                            </td>

                                                                            <td
                                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                                style={{ padding: "0.5rem" }}
                                                                            >
                                                                                <button
                                                                                    onClick={(e) => handleClick(e, evenement)}
                                                                                    style={{


                                                                                        borderRadius: "4px", // Border-radius légèrement augmenté
                                                                                        width: "25px",
                                                                                        height: "25px",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        cursor: "pointer",
                                                                                        transition: "all 0.2s",
                                                                                        margin: "0 auto" // Centrage horizontal
                                                                                    }}
                                                                                    className={`btn btn-sm btn-action action-button ${menu?.evenement?.id === evenement.id
                                                                                        ? "active"
                                                                                        : ""
                                                                                        }`}
                                                                                    aria-label="Actions"
                                                                                >
                                                                                    <FaEllipsisV className="icon" />
                                                                                </button>
                                                                            </td>

                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="8" className="text-center">
                                                                            Aucun évènement trouvé
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                        {menu && createPortal(
                                                            <div
                                                                ref={menuRef}
                                                                className="context-menu"
                                                                style={{
                                                                    position: "fixed",
                                                                    top: `${menu.y}px`,
                                                                    left: `${menu.x - 120}px`,
                                                                    backgroundColor: "white",
                                                                    boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                                                                    borderRadius: "4px",
                                                                    zIndex: 1000,
                                                                    minWidth: "150px",
                                                                    border: "1px solid #ddd",
                                                                    padding: "5px 0",
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                                                    <li className="context-menu-item"
                                                                        style={{
                                                                            padding: "8px 16px",
                                                                            cursor: "pointer",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            ":hover": {
                                                                                backgroundColor: "#f5f5f5",
                                                                            }
                                                                        }}
                                                                        onClick={() => {
                                                                            navigate(`/Liste-signalements`, {
                                                                                state: {
                                                                                    evenement_id: menu.evenement.evenement_id,
                                                                                    evenement_nom: menu.evenement.nom,
                                                                                }
                                                                            });
                                                                            closeMenu();
                                                                        }}
                                                                    >
                                                                        <FaEdit style={{ color: "#117cf5", marginRight: "8px" }} />
                                                                        Examiner
                                                                    </li>
                                                                    <li className="context-menu-item"
                                                                        style={{
                                                                            padding: "8px 16px",
                                                                            cursor: "pointer",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            ":hover": {
                                                                                backgroundColor: "#f5f5f5",
                                                                            }
                                                                        }}
                                                                        onClick={async () => {
                                                                            try {
                                                                                await notifierHoster(menu.evenement.evenement_id);
                                                                                showAlert("Hoster notifié avec succès", "success");
                                                                                closeMenu();
                                                                            } catch (error) {
                                                                                showAlert("Erreur lors de la notification du hoster", "danger");
                                                                            }
                                                                        }}
                                                                    >
                                                                        <FaBell style={{ color: "#0a3764", marginRight: "8px" }} />
                                                                        Notifier
                                                                    </li>
                                                                    <li className="context-menu-item"
                                                                        style={{
                                                                            padding: "8px 16px",
                                                                            cursor: "pointer",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            ":hover": {
                                                                                backgroundColor: "#f5f5f5",
                                                                            }
                                                                        }}
                                                                        onClick={() => {
                                                                            setEvenementAModifier(menu.evenement);
                                                                            setShowSuspendModal(true);
                                                                            closeMenu();
                                                                        }}
                                                                    >
                                                                        <FaBan style={{ color: "#dc3545", marginRight: "8px" }} />
                                                                        Suspendre
                                                                    </li>
                                                                    <li className="context-menu-item"
                                                                        style={{
                                                                            padding: "8px 16px",
                                                                            cursor: "pointer",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            ":hover": {
                                                                                backgroundColor: "#f5f5f5",
                                                                            }
                                                                        }}
                                                                        onClick={() => {
                                                                            setEvenementAModifier(menu.evenement);
                                                                            setShowRetirerModal(true);
                                                                            closeMenu();
                                                                        }}
                                                                    >
                                                                        <FaUndo style={{ color: "#28a745", marginRight: "8px" }} />
                                                                        Restaurer
                                                                    </li>
                                                                </ul>
                                                            </div>,
                                                            document.body
                                                        )}
                                                    </div>
                                                    {/* Pagination Controls */}
                                                    <div className="d-flex justify-content-between align-items-center mt-3">

                                                        <div
                                                            className="dataTables_info"
                                                            role="status"
                                                            aria-live="polite"
                                                        >
                                                            {totalItems === 0
                                                                ? "Aucun élément à afficher"
                                                                : `Élément ${currentPage === 1
                                                                    ? 1
                                                                    : (currentPage - 1) * itemsPerPage + 1
                                                                } à ${currentPage * itemsPerPage > totalItems
                                                                    ? totalItems
                                                                    : currentPage * itemsPerPage
                                                                } sur ${totalItems}`}
                                                        </div>

                                                        <div>
                                                            {Array.from({ length: totalPages }, (_, index) => (
                                                                <button
                                                                    key={index + 1}
                                                                    onClick={() => setCurrentPage(index + 1)}
                                                                    className={`btn ${currentPage === index + 1
                                                                        ? "btn-default"
                                                                        : "btn-light"
                                                                        } mx-1`}
                                                                >
                                                                    {index + 1}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div role="tabpanel" id="tab-2" className="tab-pane">
                                            <div className="panel-body">
                                                <div className="ibox">

                                                    <div
                                                        className="d-flex justify-content-between align-items-center mb-3"
                                                        style={{ gap: "10px" }}
                                                    >
                                                        <div
                                                            className="d-flex align-items-center"
                                                            style={{ gap: "10px" }}
                                                        >
                                                            <select
                                                                id="itemsPerPage"
                                                                value={itemsPerPage}
                                                                onChange={(e) => {
                                                                    setItemsPerPage(Number(e.target.value));
                                                                    setCurrentPage(1);
                                                                }}
                                                                className="form-select bg-default p-1"
                                                                style={{
                                                                    width: "auto",
                                                                    border: "1px black solid",
                                                                    borderRadius: "5px",
                                                                }}
                                                            >
                                                                <option value={10}>10</option>
                                                                <option value={20}>20</option>
                                                                <option value={50}>50</option>
                                                            </select>
                                                            {/* <select
                                                                value={filtreStatut}
                                                                onChange={(e) =>
                                                                    setFiltreStatut(e.target.value)
                                                                }
                                                                className="form-select bg-default p-1"
                                                                style={{
                                                                    width: "auto",
                                                                    border: "1px black solid",
                                                                    borderRadius: "5px",
                                                                }}
                                                            >
                                                                <option value="tous">Tous</option>
                                                                <option value="Suspendu">Suspendu</option>
                                                                <option value="Retiré">Restauré</option>
                                                            </select> */}
                                                        </div>

                                                        <input
                                                            type="text"
                                                            placeholder="Rechercher..."
                                                            className="form-control"
                                                            style={{ maxWidth: "250px", width: "100%" }}
                                                            value={searchTerm}
                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="table-responsive">
                                                        <table
                                                            className="footable table table-stripped footable-loaded tablet breakpoint"
                                                            data-page-size="8"
                                                            data-filter="#filter"
                                                            style={{ fontSize: "12px" }}
                                                        >
                                                            <thead>

                                                                <tr>
                                                                    <th
                                                                        className="text-secondary text-wrap  d-none d-md-table-cell"
                                                                        onClick={() => handleSortTraitements("nom")}
                                                                        style={{ width: "20%", minWidth: "100px" }}
                                                                    >
                                                                        Nom
                                                                        {sortConfig.key === "nom"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>
                                                                    <th
                                                                        className="text-secondary text-wrap  d-none d-md-table-cell"
                                                                        onClick={() => handleSortTraitements("date_traitement")}
                                                                        style={{ width: "20%", minWidth: "100px" }}
                                                                    >
                                                                        Date traitement
                                                                        {sortConfig.key === "date_traitement"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>
                                                                    <th
                                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell  align-middle"
                                                                        onClick={() => handleSortTraitements("action")}
                                                                        style={{ width: "18%", minWidth: "100px" }}
                                                                    >
                                                                        Action
                                                                        {sortConfig.key === "action"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>
                                                                    <th
                                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell"
                                                                        onClick={() => handleSortTraitements("nombre_signalement")}
                                                                        style={{ width: "25%", minWidth: "100px" }}
                                                                    >
                                                                        Nombre signalements
                                                                        {sortConfig.key === "nombre_signalement"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell  align-middle"
                                                                        onClick={() => handleSort("traite_par")}
                                                                        style={{ width: "20%", minWidth: "80px" }}
                                                                    >
                                                                        Traité par
                                                                        {sortConfig.key === "traite_par"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                    </th>
                                                                    <th
                                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell"
                                                                        style={{ width: "1%", minWidth: "60px" }}
                                                                    >
                                                                        Détails
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentTraitements && currentTraitements.length > 0 ? (
                                                                    currentTraitements.map((traitement) => (
                                                                        <tr
                                                                            key={traitement.id}

                                                                        >


                                                                            <td
                                                                                className="d-none d-md-table-cell  align-middle"
                                                                                style={{ padding: "0.5rem" }}
                                                                            >
                                                                                <span>{traitement.nom}</span>
                                                                            </td>
                                                                            <td
                                                                                className="d-none d-md-table-cell  align-middle"
                                                                                style={{ padding: "0.5rem" }}
                                                                            >
                                                                                <span>{traitement.date_traitement}</span>
                                                                            </td>
                                                                            <td
                                                                                className="d-none d-md-table-cell align-middle text-center"
                                                                                style={{ padding: "0.5rem" }}
                                                                            >
                                                                                {traitement.action === "restaure" ? (
                                                                                    <span className="badge bg-success text-capitalize">{traitement.action}</span>
                                                                                ) : traitement.action === "suspendu" ? (
                                                                                    <span className="badge bg-secondary text-white text-capitalize">{traitement.action}</span>
                                                                                ) : (
                                                                                    <span className="badge bg-info text-capitalize">{traitement.action}</span>
                                                                                )}
                                                                            </td>
                                                                            <td
                                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                                style={{ padding: "0.5rem" }}>
                                                                                <div className="fw-semibold">{traitement.nombre_signalement}</div>
                                                                            </td>
                                                                            <td
                                                                                className="d-none d-md-table-cell  align-middle"
                                                                                style={{ padding: "0.5rem" }}>
                                                                                <div className="fw-semibold">{traitement.traite_par}</div>
                                                                            </td>
                                                                            <td className="d-none d-md-table-cell text-center align-middle" style={{ padding: "0.5rem" }}>
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        navigate(`/Liste-signalements`, {
                                                                                            state: {
                                                                                                traitement_id: traitement.id,
                                                                                                evenement_nom: traitement.nom,
                                                                                                isTraitement: true
                                                                                            }
                                                                                        });
                                                                                    }}
                                                                                    style={{
                                                                                        borderRadius: "4px",
                                                                                        width: "25px",
                                                                                        height: "25px",
                                                                                        padding: "6px",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        cursor: "pointer",
                                                                                        transition: "all 0.2s",
                                                                                        margin: "0 auto"
                                                                                    }}
                                                                                    className="btn btn-sm btn-action action-button"
                                                                                    aria-label="Details"
                                                                                >
                                                                                    <FaEye className="icon" size={20} />
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="8" className="text-center">
                                                                            Aucun traitement trouvé
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                    {/* Pagination Controls */}
                                                    <div className="d-flex justify-content-between align-items-center mt-3">

                                                        <div
                                                            className="dataTables_info"
                                                            role="status"
                                                            aria-live="polite"
                                                        >
                                                            {totalItems === 0
                                                                ? "Aucun élément à afficher"
                                                                : `Élément ${currentPage === 1
                                                                    ? 1
                                                                    : (currentPage - 1) * itemsPerPage + 1
                                                                } à ${currentPage * itemsPerPage > totalItems
                                                                    ? totalItems
                                                                    : currentPage * itemsPerPage
                                                                } sur ${totalItems}`}
                                                        </div>

                                                        <div>
                                                            {Array.from({ length: totalPages }, (_, index) => (
                                                                <button
                                                                    key={index + 1}
                                                                    onClick={() => setCurrentPage(index + 1)}
                                                                    className={`btn ${currentPage === index + 1
                                                                        ? "btn-default"
                                                                        : "btn-light"
                                                                        } mx-1`}
                                                                >
                                                                    {index + 1}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>

            {/* Modal de confirmation de retrait */}
            <Modal show={showRetirerModal} onHide={() => setShowRetirerModal(false)} centered size="sm" style={{ fontSize: "11px" }}>
                <Modal.Body className="text-center">
                    <FaUndo className="text-restaure mb-3" size={60} style={{ marginTop: "-15px" }} />
                    <p>Êtes-vous sûr de vouloir restaurer cet évènement ?</p>
                </Modal.Body>
                <Modal.Footer className="border-top-0 flex-column align-items-center" style={{ marginTop: "-40px" }}>
                    <div className="d-flex justify-content-center mb-2">
                        <Button variant="secondary" className="mr-5 px-4" onClick={() => setShowRetirerModal(false)}>
                            Non
                        </Button>
                        <Button variant="primary" className="px-4" onClick={() => {
                            handleRestoreEvent(evenementAModifier);
                            setShowRetirerModal(false);
                        }}>
                            Oui
                        </Button>
                    </div>
                    <small className="text-muted text-center mb-3">
                        Cet événement sera remis en fil d'actualité.
                    </small>
                </Modal.Footer>
            </Modal>

            {/* Modal de confirmation de suspension */}
            <Modal show={showSuspendModal} onHide={() => setShowSuspendModal(false)} centered size="sm" style={{ fontSize: "11px" }}>
                <Modal.Body className="text-center">
                    <FaBan className="text-danger mb-3" size={60} style={{ marginTop: "-15px" }} />
                    <p>Êtes-vous sûr de vouloir suspendre cet évènement ?</p>
                </Modal.Body>
                <Modal.Footer className="border-top-0 flex-column align-items-center" style={{ marginTop: "-40px" }}>
                    <div className="d-flex justify-content-center mb-2">
                        <Button variant="secondary" className="mr-5 px-4" onClick={() => setShowSuspendModal(false)}>
                            Non
                        </Button>
                        <Button variant="danger" className="px-4" onClick={() => {
                            handleSuspendEvent(evenementAModifier);
                            setShowSuspendModal(false);
                        }}>
                            Oui
                        </Button>
                    </div>
                    <small className="text-muted text-center mb-3">
                        Cette action est irréversible et empêchera tout accès à l'événement.
                    </small>
                </Modal.Footer>
            </Modal>


        </div>
    );
};

export default ListeEvenementSignales;
